export enum Maps {
  GOOGLE = 'google',
  ESRI = 'esri',
}
